import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { LoungeServiceRequestService } from '@common/services/my-booking/lounge-service-request/lounge-service-request.service';
import { SupportModalIdSubComponent } from '@lib/components/support-class';
import { CommonLibService } from '@lib/services';
import { Subscription } from 'rxjs';

@Component({
  selector: 'asw-lounge-service-request-footer',
  templateUrl: './lounge-service-request-footer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoungeServiceRequestFooterComponent extends SupportModalIdSubComponent {
  subscription: Subscription = new Subscription();
  screenInformationChangeFlag = false;

  public applyEvent: () => void = () => {};

  constructor(
    private _common: CommonLibService,
    private _loungeServiceRequestService: LoungeServiceRequestService,
    private _changeDetector: ChangeDetectorRef
  ) {
    super(_common);
  }

  init() {
    this.subscription.add(
      this._loungeServiceRequestService.screenInformationChangeFlag.subscribe((flag) => {
        this.screenInformationChangeFlag = flag;
        this._changeDetector.markForCheck();
      })
    );
  }

  onClickApply() {
    this.applyEvent();
  }

  reload() {}

  destroy() {}
}
